import React, { useState, useEffect } from 'react';
import { Icon, Toolbar, ToolbarItem } from '@emorg-prd/standard-react';
import { Button, ButtonGroup } from '../../common/';
import OrganizationTuple from '../../../models/entities/OrganizationTuple';
import ResourceTabs from '../../common/ResourceTabs';
import Filter from '../../common/tables/Filter';
import OrganizationsService from '../../../services/OrganizationsService';
import CSVGeneratorButton from '../../common/CSVGeneratorButton';

type OrganizationsFilters = {
	searchGeneral: string;
	showResources: string;
};

interface OrganizationHomeFiltersProps {
	filteredOrganizations: OrganizationTuple[];
	setFilteredOrganizations: any;
	allOrganizations: OrganizationTuple[];
	retreiveOrganizations: any;
	setDecisionModalVisible: any;
	setL3: any;

}

const OrganizationsHomeFilters = ({
	allOrganizations,
	setFilteredOrganizations,
	retreiveOrganizations,
	setDecisionModalVisible,
	setL3
}: OrganizationHomeFiltersProps) => {

	const organizationsService = new OrganizationsService();
	const defaultFilters = {
		searchGeneral: '',
		showResources: allOrganizations[0].item1,
	};

	const filterOrganizations = () => {
		let filtered = [];

		const filterCallback = (org: OrganizationTuple) => {
			return (
				filter.filterSearchText('searchGeneral', org.item1.toLowerCase())
			);

		};

		filtered = allOrganizations.filter(filterCallback);

		filtered = filtered.filter(
			(org: OrganizationTuple) => {
				if (org.item1 == filter.filters.showResources) {
					organizationsService.getByDisplayName(org.item1).then((res) => setL3(res));
					return org
				}
			}
		);

		setFilteredOrganizations(filtered);
	};

	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	const handleRefresh = () => {
		filter.updateFilter(allOrganizations[0].item1, 'showResources');
		retreiveOrganizations(true);
	};

	useEffect(() => {
		filter.updateFilterFunction(filterOrganizations);
	}, [allOrganizations]);

	useEffect(() => {
		filter.filter();
	}, []);

	const [filter] = useState<Filter<OrganizationsFilters>>(new Filter(filterOrganizations, defaultFilters));

	const exportOrganizationData = () => {
		return allOrganizations.flatMap((orgl3) => {
			if (orgl3.item2.length === 0) {
				return [{ l3: orgl3.item1, l4: "", l5: "" }];
			}

			return orgl3.item2.flatMap((orgl4) => {
				if (orgl4.item2.length === 0) {
					return [{ l3: orgl3.item1, l4: orgl4.item1.displayName, l5: "" }];
				}

				return orgl4.item2.map((orgl5) => ({
					l3: orgl3.item1,
					l4: orgl4.item1.displayName,
					l5: orgl5.displayName,
				}));
			});
		});
	};

	return (
		<>
			{filter && (
				<>
					<ResourceTabs
						allResources={allOrganizations}
						filter={filter}
					/>
					<Toolbar id="toggle-toolbar">
						<ToolbarItem alignRight>
							<ButtonGroup>
								<Button
									variant="primary"
									size="small"
									onClick={() => setDecisionModalVisible({ ['createOrEditOrg']: true })}
									isLoading={false}
									disabled={false}
									name=""
									loadingVariant="primary"
								>
									<Icon name="plus" size="em-c-icon--small" />
									<span>Create new L4/L5</span>
								</Button>
								<CSVGeneratorButton
									data={exportOrganizationData()}
									fileName={`Organizations.csv`}
									columns={
										[
											{ header: 'L3', cell: (orgData) => orgData.l3 },
											{ header: 'L4', cell: (orgData) => orgData.l4 },
											{ header: 'L5', cell: (orgData) => orgData.l5 }
										]
									}
								/>
								<Button
									variant="secondary"
									size="small"
									onClick={handleRefresh}
									isLoading={false}
									disabled={false}
									name=""
									loadingVariant="secondary"
								>
									<Icon name="refresh" size="em-c-icon--small" />
									<span> Refresh </span>
								</Button>
							</ButtonGroup>
						</ToolbarItem>
					</Toolbar>
				</>
			)}
		</>
	);
};

export default OrganizationsHomeFilters;